export default __webpack_public_path__ + "static/media/magic.0ee11a67.svg";